import React, { useEffect, type ReactNode } from 'react';
import { ConfigProvider, theme } from 'antd';
import type { ThemeConfig } from 'antd';
import { getWindowSize } from '@wavvest/shared-utils';

export interface LoginLayoutProps {
  children: ReactNode;
  /** Ant Design component-level token overrides merged on top of darkAlgorithm. */
  themeComponents?: ThemeConfig['components'];
  /** Ant Design global token overrides (e.g. colorPrimary for firm branding). */
  themeToken?: ThemeConfig['token'];
  /** CSS class applied to the outer container div. Defaults to "main". */
  className?: string;
  /** Ant Design color algorithm. Defaults to darkAlgorithm. */
  algorithm?: ThemeConfig['algorithm'];
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({
  children,
  themeComponents,
  themeToken,
  className = 'main',
  algorithm = theme.darkAlgorithm,
}) => {
  useEffect(() => {
    const handleResize = () => {
      const { width, height } = getWindowSize();
      const el = document.getElementById('loginMain');
      if (el) {
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ConfigProvider
      theme={{
        algorithm,
        components: themeComponents,
        token: themeToken,
      }}
    >
      <div className={className} id="loginMain">
        {children}
      </div>
    </ConfigProvider>
  );
};
